import { requestBuilder } from '../../http/RequestBuilder';
import type { GetTransactionsResponse } from '../types/activities';

export const useGetApexActivities = (apexAccountId: string) => {
    return requestBuilder.query<
        GetTransactionsResponse,
        { apexAccountId: string }
    >({
        endpoint: ({ apexAccountId }) =>
            `/api/investments/${apexAccountId}/transactions`,
        queryKey: ({ apexAccountId }) =>
            `/api/investments/${apexAccountId}/transactions`,
    })({ apexAccountId });
};
